// eslint-disable-next-line no-restricted-imports
import { css } from 'styled-components';
import styled from 'styled-components/macro';

import { colors } from 'styles/colors';

import {
	buttonBorderRadius,
	setButtonFontSize,
	buttonFontWeight,
	setButtonLineHeight,
	setButtonPadding,
} from './Button.helper';

// TODO: This file is crying for TypeScript :)

const setButtonBorder = (variant) => {
	if (variant === 'secondary') {
		return `1px solid ${colors.blue}`;
	} else if (variant === 'tertiary') {
		return `1px solid ${colors.navy}`;
	} else {
		return 'none';
	}
};

export const Container = styled.button`
	align-items: center;
	background-color: ${({ variant }) =>
		variant === 'cancel' ? 'transparent' : colors.white};
	border-radius: ${({ rounded }) =>
		rounded ? buttonBorderRadius.rounded.max : buttonBorderRadius.circle};
	border: ${({ variant }) => setButtonBorder(variant)};
	color: ${({ variant }) => variant === 'cancel' && colors.darkGrey};
	cursor: pointer;
	display: flex;
	font-size: ${({ variant, small }) => setButtonFontSize(variant, small)};
	font-weight: ${({ variant }) =>
		variant === 'tertiary' ? buttonFontWeight.default : buttonFontWeight.xxl};
	justify-content: center;
	line-height: ${({ variant, small }) => setButtonLineHeight(variant, small)};
	margin: ${({ margin }) => margin};
	overflow: hidden;
	padding: ${({ icon, small }) => setButtonPadding(icon, small)};
	position: relative;
	width: ${({ width }) => width || 'auto'};
	z-index: 0;
	// Primary
	background-image: ${({ variant }) =>
		variant === 'primary' && colors.gradient};
	${({ variant }) =>
		variant === 'primary' &&
		css`
			&:before {
				content: '';
				background-color: ${colors.white};
				border-radius: ${({ rounded }) =>
					rounded ? buttonBorderRadius.rounded.min : 'inherit'};
				bottom: 1px;
				box-sizing: border-box;
				left: 1px;
				position: absolute;
				right: 1px;
				top: 1px;
				z-index: -1;
			}
		`}

	&:hover {
		box-shadow: ${({ variant }) =>
			variant !== 'cancel' && css`0px 4px 8px ${colors.black20}`};

		// Primary
		${({ variant }) =>
			variant === 'primary' &&
			css`
				background-image: ${colors.white};

				&:before {
					content: '';
					background-image: ${colors.gradientBlue};
				}

				span {
					background: ${colors.gradientText};
					background-clip: text;
					-webkit-background-clip: text;
					-webkit-text-fill-color: transparent;
				}

				img {
					filter: brightness(0) invert(1);
				}
			`}

		// Secondary
		${({ variant }) =>
			variant === 'secondary' &&
			css`
				background-color: ${colors.blue};

				span {
					color: ${colors.white};
				}
			`}

		// Tertiary
		${({ variant }) =>
			variant === 'tertiary' &&
			css`
				background-color: ${colors.navy};

				span {
					color: ${colors.white};
				}
			`}

		// Cancel
		${({ variant }) =>
			variant === 'cancel' &&
			css`
				color: ${colors.navy};
			`}
	}

	&:disabled {
		background: ${colors.grey20};
		box-shadow: none;
		cursor: not-allowed;
		border: none;

		&:before {
			content: '';
			background: ${colors.grey20};
		}

		&:hover {
			background: ${colors.grey20};
			box-shadow: none;
			cursor: not-allowed;
			border: none;

			&:before {
				content: '';
				background: ${colors.grey20};
			}

			span {
				background: ${colors.darkGrey};
				background-clip: text;
				-webkit-background-clip: text;
				-webkit-text-fill-color: transparent;
			}

			img {
				filter: none;
			}
		}

		span {
			background: ${colors.darkGrey};
			background-clip: text;
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
		}
	}
`;

export const Label = styled.span`
	// Primary
	${({ variant }) =>
		variant === 'primary' &&
		css`
			background-clip: text;
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			background-image: ${colors.gradient};
		`}
	// Secondary
	${({ variant }) =>
		variant === 'secondary' &&
		css`
			color: ${colors.blue};
		`}
	// Tertiary
	${({ variant }) =>
		variant === 'tertiary' &&
		css`
			color: ${colors.navy};
		`}
`;

export const Icon = styled.img`
	height: ${({ small }) => small && '15px'};
	margin-right: 11px;
	width: ${({ small }) => small && '15px'};
`;

export const EmailLink = styled.a.attrs((props) => ({
	href: props.href || 'mailto:help@cenegenics.com',
}))`
	color: ${colors.blue};
	font-weight: 600;
	text-decoration: none;
`;
